import {
  createContext,
  useContext,
  type ReactElement,
  type ReactNode
} from "react";
import type { ViewerTopNavModel } from "../topNav/ViewerTopNav";

const ViewerShellModelContext = createContext<ViewerTopNavModel | null>(null);

export function ViewerShellModelProvider(props: {
  value: ViewerTopNavModel | null;
  children: ReactNode;
}): ReactElement {
  return (
    <ViewerShellModelContext.Provider value={props.value}>
      {props.children}
    </ViewerShellModelContext.Provider>
  );
}

export function useViewerShellModel(): ViewerTopNavModel | null {
  return useContext(ViewerShellModelContext);
}
